export default __webpack_public_path__ + "static/media/nucleo-icons.19abb540.eot";